import React from "react";
import { motion } from "framer-motion";
import styles from "./FineArts.module.css";
import { useNavigate } from "react-router-dom";

const artMediums = [
  {
    title: "Oil Painting",
    desc: "Master the classical techniques of glazing and impasto.",
    image:
      "/assets/imgs/gallery/oil_color.jpeg",
  },
  {
    title: "Water Color",
    desc: "Explore transparency, fluid movement, and light control.",
    image:
      "https://images.unsplash.com/photo-1513364776144-60967b0f800f?q=80&w=1000",
  },
  {
    title: "Pastel Art",
    desc: "Capture vibrant pigments with soft and oil pastel blending.",
    image:
      "/assets/imgs/gallery/oil_pastel.jpg",
  },
  {
    title: "Graphite & Charcoal",
    desc: "Foundation skills in anatomy, depth, and dramatic shading.",
    image:
      "/assets/imgs/gallery/graphite.jpg"
  },
  {
    title: "Color Pencil",
    desc: "High-detail realism through layering and burnishing.",
    image:
      "/assets/imgs/gallery/pencil-sketching.png",
  },
  {
    title: "Acrylic Painting",
    desc: "Modern versatility with fast-drying textures and layers.",
    image:
      "/assets/imgs/gallery/acrylic_420_280.jpg",
  },
];

const FineArts: React.FC = () => {
  const navigate = useNavigate(); //

  const handleDetailsClick = (courseTitle: string) => {
    // We convert "Oil Painting" to "oil-painting" for the URL
    const slug = courseTitle
    .toLowerCase()
    .replace(/&/g, 'and')    // Replace & with 'and'
    .replace(/[\s\W-]+/g, '-') // Replace spaces and non-word chars with -
    .replace(/^-+|-+$/g, '');  // Clean up leading/trailing hyphens
    navigate(`/course/${slug}`); //
  };
  return (
    <div className={styles.container}>
      <header className={styles.header}>
        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className={styles.title}
        >
          Fine Arts
        </motion.h1>
        <p className={styles.subtitle}>
          Where classical tradition meets modern expression.
        </p>
      </header>

      <div className={styles.grid}>
        {artMediums.map((art, index) => (
          <motion.div
            key={index}
            className={styles.card}
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            whileHover={{ y: -10 }}
          >
            <div className={styles.imageWrapper}>
              <img
                src={art.image}
                alt={art.title}
                className={styles.artImage}
              />
              <div className={styles.overlay} />
            </div>
            <div className={styles.cardContent}>
              <h3>{art.title}</h3>
              <p>{art.desc}</p>
              <button className={styles.detailsBtn} onClick={() => handleDetailsClick(art.title)}>
                Details <span className={styles.arrow}>→</span>
              </button>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default FineArts;
